import axios from "axios";
axios.defaults.headers.common["Is-Axios"] = true;
axios.defaults.headers["X-Requested-With"] = "Axios";
import Utilities from "../../../Helpers/Utilities";
import { receivedServerError, receivedUnauthorizedError, receivedExpiredSessionError } from "../../Error/Actions";
import { toggleBlockingStatus, updateRequestCount } from "../../Status/Actions";
import { redirectToLoginPage } from "../../Account/Actions";
import _ from "lodash";
import Constants from "../../../AppConstants/Constants";
import {
    CATEGORIES_RECEIVED,
    NEW_PRODUCTS_RECEIVED,
    KITS_RECEIVED,
    DEVICES_RECEIVED,
    VTRACK_ITEMS_RECEIVED,
    LINEHAUL_ITEMS_RECEIVED,
    ACCESSORIES_RECEIVED,
    ZEBRA_ACCESSORIES_RECEIVED,
    ZEBRA_TC26_ACCESSORIES_RECEIVED,
    ZEBRA_TC58_ACCESSORIES_RECEIVED,
    ZEBRA_TC78_ACCESSORIES_RECEIVED,
    PANASONIC_ACCESSORIES_RECEIVED,
    PANASONIC_T1_ACCESSORIES_RECEIVED,
    SAMSUNG_ACCESSORIES_RECEIVED,
    UNIVERSAL_ACCESSORIES_RECEIVED,
    PLANS_RECEIVED,
    SERVICES_RECEIVED,
    CATEGORY_PRODUCTS_RECEIVED,
    KIT_QUANTIY_UPDATED,
    DEVICE_QUANTIY_UPDATED,
    PRODUCT_SELECTED,
    RENTALS_RECEIVED
} from "../Constants";
import Category from "../../../Components/Common/Category";

export function getCategories(cb) {
    return function(dispatch, getState) {
        dispatch(toggleBlockingStatus(true));
        dispatch(updateRequestCount(true));

        return axios.get(Utilities.buildUrl("/Catalog/Categories"))
            .then(res => {
                const state = getState();
                const { DEVICES_CATEGORY_ID, ZEBRA_ACCESSORIES_CATEGORY_ID, PANASONIC_T1_ACCESSORIES_CATEGORY_ID, PANASONIC_ACCESSORIES_CATEGORY_ID, UNIVERSAL_ACCESSORIES_CATEGORY_ID } = state.config;
                const locale = state.i18n;

                _.each(res.data.categories, category => {
                    if (category.id === DEVICES_CATEGORY_ID) {
                        category.showOnHomePage = true;
                        category.description = locale.translations[locale.locale].home.categories.devices.description;
                        category.pageUrl = Constants.ENDPOINTS.DEVICES;
                    }

                    if (category.subCategories && category.subCategories.length > 0) {
                        _.each(category.subCategories, item => {
                            if (item.id === ZEBRA_ACCESSORIES_CATEGORY_ID ||
                                item.id === PANASONIC_ACCESSORIES_CATEGORY_ID ||
                                item.id === UNIVERSAL_ACCESSORIES_CATEGORY_ID) {
                                item.showOnHomePage = true;
                            } else {
                                item.showOnHomePage = false;
                            }

                            if (item.id === ZEBRA_ACCESSORIES_CATEGORY_ID) {
                                item.description = locale.translations[locale.locale].home.categories.zebra.description;
                                item.pageUrl = Constants.ENDPOINTS.ZEBRA_ACCESSORIES;
                            }
                            if (item.id === PANASONIC_ACCESSORIES_CATEGORY_ID) {
                                item.description = locale.translations[locale.locale].home.categories.panasonic.description;
                                item.pageUrl = Constants.ENDPOINTS.PANASONIC_ACCESSORIES;
                            }
                            if (item.id === UNIVERSAL_ACCESSORIES_CATEGORY_ID) {
                                item.pageUrl = Constants.ENDPOINTS.UNIVERSAL_ACCESSORIES;
                            }
                        });
                    }
                });

                dispatch(receivedServerError(false));
                dispatch(receivedCategories(res.data.categories));
                dispatch(updateRequestCount(false));

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }

                cb(res.data.categories);
            })
            .catch(error => {
                dispatch(updateRequestCount(false));

                if (error.response.status === 401 || error.response.status === 403) {
                    dispatch(redirectToLoginPage());
                } else {
                    dispatch(receivedServerError(true, error.response.data));
                    dispatch(receivedServerError(false));
                }

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }
            });
    };
}

function receivedCategories(data) {
    return {
        type: CATEGORIES_RECEIVED,
        payload: data
    };
}

export function getNewProducts(includeSpecs = false, includeAttributes = false, includeSubProducts = false, pageNumber = 1) {
    return function(dispatch, getState) {
        dispatch(toggleBlockingStatus(true));
        dispatch(updateRequestCount(true));

        return axios.get(Utilities.buildUrl("/Catalog/NewProducts"), {
            params: { includeSpecs, includeAttributes, includeSubProducts, pageNumber }
        })
            .then(res => {
                dispatch(receivedServerError(false));
                dispatch(receivedNewProducts(res.data.products));
                dispatch(updateRequestCount(false));

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }
            })
            .catch(error => {
                dispatch(updateRequestCount(false));

                if (error.response.status === 401 || error.response.status === 403) {
                    redirectToLoginPage();
                } else {
                    dispatch(receivedServerError(true, error.response.data));
                    dispatch(receivedServerError(false));
                }

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }
            });
    };
}

function receivedNewProducts(data) {
    return {
        type: NEW_PRODUCTS_RECEIVED,
        payload: data
    };
}

export function getCategoryProducts(categoryId, includeSpecs = false, includeAttributes = false, includeSubProducts = false, pageNumber = 1) {
    return function(dispatch, getState) {
        dispatch(toggleBlockingStatus(true));
        dispatch(updateRequestCount(true));

        return axios.get(Utilities.buildUrl("/Catalog/CategoryProducts"), {
            params: { categoryId, includeSpecs, includeAttributes, includeSubProducts, pageNumber }
        })
            .then(res => {
                dispatch(receivedServerError(false));
                dispatch(receivedCategoryProducts(res.data.products));
                dispatch(updateRequestCount(false));

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }
            })
            .catch(error => {
                dispatch(updateRequestCount(false));

                if (error.response.status === 401 || error.response.status === 403) {
                    redirectToLoginPage();
                } else {
                    dispatch(receivedServerError(true, error.response.data));
                    dispatch(receivedServerError(false));
                }

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }
            });
    };
}

function receivedCategoryProducts(data) {
    return {
        type: CATEGORY_PRODUCTS_RECEIVED,
        payload: data
    };
}

export function getKits(categoryId, includeSpecs = false, includeAttributes = false, includeSubProducts = false, pageNumber = 1) {
    return function(dispatch, getState) {
        dispatch(toggleBlockingStatus(true));
        dispatch(updateRequestCount(true));

        return axios.get(Utilities.buildUrl("/Catalog/CategoryProducts"), {
            params: { categoryId, includeSpecs, includeAttributes, includeSubProducts, pageNumber }
        })
            .then(res => {
                dispatch(receivedServerError(false));
                dispatch(receivedKits(res.data.products));
                dispatch(updateRequestCount(false));

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }
            })
            .catch(error => {
                dispatch(updateRequestCount(false));

                if (error.response.status === 401 || error.response.status === 403) {
                    redirectToLoginPage();
                } else {
                    dispatch(receivedServerError(true, error.response.data));
                    dispatch(receivedServerError(false));
                }

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }
            });
    };
}

function receivedKits(data) {
    return {
        type: KITS_RECEIVED,
        payload: data
    };
}

export function getRentals(categoryId, includeSpecs = false, includeAttributes = false, includeSubProducts = false, pageNumber = 1) {
    return function(dispatch, getState) {
        dispatch(toggleBlockingStatus(true));
        dispatch(updateRequestCount(true));

        return axios.get(Utilities.buildUrl("/Catalog/CategoryProducts"), {
            params: { categoryId, includeSpecs, includeAttributes, includeSubProducts, pageNumber }
        })
            .then(res => {
                dispatch(receivedServerError(false));
                dispatch(receivedRentals(res.data.products));
                dispatch(updateRequestCount(false));

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }
            })
            .catch(error => {
                dispatch(updateRequestCount(false));

                if (error.response.status === 401 || error.response.status === 403) {
                    redirectToLoginPage();
                } else {
                    dispatch(receivedServerError(true, error.response.data));
                    dispatch(receivedServerError(false));
                }

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }
            });
    };
}

function receivedRentals(data) {
    return {
        type: RENTALS_RECEIVED,
        payload: data
    };
}

export function getDevices(categoryId, includeSpecs = false, includeAttributes = false, includeSubProducts = false, pageNumber = 1, cb) {
    return function(dispatch, getState) {
        dispatch(toggleBlockingStatus(true));
        dispatch(updateRequestCount(true));

        return axios.get(Utilities.buildUrl("/Catalog/CategoryProducts"), {
            params: { categoryId, includeSpecs, includeAttributes, includeSubProducts, pageNumber }
        })
            .then(res => {
                dispatch(receivedServerError(false));
                dispatch(receivedDevices(res.data.products));
                dispatch(updateRequestCount(false));

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }

                if (cb && typeof cb === "function") {
                    cb();
                }
            })
            .catch(error => {
                dispatch(updateRequestCount(false));

                if (error.response.status === 401 || error.response.status === 403) {
                    redirectToLoginPage();
                } else {
                    dispatch(receivedServerError(true, error.response.data));
                    dispatch(receivedServerError(false));
                }

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }
            });
    };
}

function receivedDevices(data) {
    return {
        type: DEVICES_RECEIVED,
        payload: data
    };
}

export function getVtrackItems(categoryId, includeSpecs = false, includeAttributes = false, includeSubProducts = false, pageNumber = 1) {
    return function(dispatch, getState) {
        dispatch(toggleBlockingStatus(true));
        dispatch(updateRequestCount(true));

        return axios.get(Utilities.buildUrl("/Catalog/CategoryProducts"), {
            params: { categoryId, includeSpecs, includeAttributes, includeSubProducts, pageNumber }
        })
            .then(res => {
                dispatch(receivedServerError(false));
                dispatch(receivedVtrackItems(res.data.products));
                dispatch(updateRequestCount(false));

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }
            })
            .catch(error => {
                dispatch(updateRequestCount(false));

                if (error.response.status === 401 || error.response.status === 403) {
                    redirectToLoginPage();
                } else {
                    dispatch(receivedServerError(true, error.response.data));
                    dispatch(receivedServerError(false));
                }

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }
            });
    };
}

function receivedVtrackItems(data) {
    return {
        type: VTRACK_ITEMS_RECEIVED,
        payload: data
    };
}

export function getLineHaulItems(categoryId, includeSpecs = false, includeAttributes = false, includeSubProducts = false, pageNumber = 1) {
    return function(dispatch, getState) {
        dispatch(toggleBlockingStatus(true));
        dispatch(updateRequestCount(true));

        return axios.get(Utilities.buildUrl("/Catalog/CategoryProducts"), {
            params: { categoryId, includeSpecs, includeAttributes, includeSubProducts, pageNumber }
        })
            .then(res => {
                dispatch(receivedServerError(false));
                dispatch(receivedLineHaulItems(res.data.products));
                dispatch(updateRequestCount(false));

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }
            })
            .catch(error => {
                dispatch(updateRequestCount(false));

                if (error.response.status === 401 || error.response.status === 403) {
                    redirectToLoginPage();
                } else {
                    dispatch(receivedServerError(true, error.response.data));
                    dispatch(receivedServerError(false));
                }

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }
            });
    };
}

function receivedLineHaulItems(data) {
    return {
        type: LINEHAUL_ITEMS_RECEIVED,
        payload: data
    };
}

export function getAccessories(categoryId, includeSpecs = false, includeAttributes = false, includeSubProducts = false, pageNumber = 1) {
    return function(dispatch, getState) {
        // dispatch(toggleBlockingStatus(true));
        dispatch(updateRequestCount(true));

        return axios.get(Utilities.buildUrl("/Catalog/CategoryProducts"), {
            params: { categoryId, includeSpecs, includeAttributes, includeSubProducts, pageNumber }
        })
            .then(res => {
                dispatch(receivedServerError(false));
                dispatch(receivedAccessories(res.data.products));
                dispatch(updateRequestCount(false));

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }
            })
            .catch(error => {
                dispatch(updateRequestCount(false));

                if (error.response.status === 401 || error.response.status === 403) {
                    redirectToLoginPage();
                } else {
                    dispatch(receivedServerError(true, error.response.data));
                    dispatch(receivedServerError(false));
                }

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }
            });
    };
}

function receivedAccessories(data) {
    return {
        type: ACCESSORIES_RECEIVED,
        payload: data
    };
}

export function getZebraAccessories(categoryId, includeSpecs = false, includeAttributes = false, includeSubProducts = false, pageNumber = 1) {
    return function(dispatch, getState) {
        dispatch(toggleBlockingStatus(true));
        dispatch(updateRequestCount(true));

        return axios.get(Utilities.buildUrl("/Catalog/CategoryProducts"), {
            params: { categoryId, includeSpecs, includeAttributes, includeSubProducts, pageNumber }
        })
            .then(res => {
                dispatch(receivedServerError(false));
                dispatch(receivedZebraAccessories(res.data.products));
                dispatch(updateRequestCount(false));

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }
            })
            .catch(error => {
                dispatch(updateRequestCount(false));

                if (error.response.status === 401 || error.response.status === 403) {
                    redirectToLoginPage();
                } else {
                    dispatch(receivedServerError(true, error.response.data));
                    dispatch(receivedServerError(false));
                }

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }
            });
    };
}

function receivedZebraAccessories(data) {
    return {
        type: ZEBRA_ACCESSORIES_RECEIVED,
        payload: data
    };
}

export function getZebraTC26Accessories(categoryId, includeSpecs = false, includeAttributes = false, includeSubProducts = false, pageNumber = 1) {
    return function (dispatch, getState) {
        dispatch(toggleBlockingStatus(true));
        dispatch(updateRequestCount(true));

        return axios.get(Utilities.buildUrl("/Catalog/CategoryProducts"), {
            params: { categoryId, includeSpecs, includeAttributes, includeSubProducts, pageNumber }
        })
            .then(res => {
                dispatch(receivedServerError(false));
                dispatch(receivedZebraTC26Accessories(res.data.products));
                dispatch(updateRequestCount(false));

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }
            })
            .catch(error => {
                dispatch(updateRequestCount(false));

                if (error.response.status === 401 || error.response.status === 403) {
                    redirectToLoginPage();
                } else {
                    dispatch(receivedServerError(true, error.response.data));
                    dispatch(receivedServerError(false));
                }

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }
            });
    };
}

function receivedZebraTC26Accessories(data) {
    return {
        type: ZEBRA_TC26_ACCESSORIES_RECEIVED,
        payload: data
    };
}

export function getZebraTC58Accessories(categoryId, includeSpecs = false, includeAttributes = false, includeSubProducts = false, pageNumber = 1) {
    return function (dispatch, getState) {
        dispatch(toggleBlockingStatus(true));
        dispatch(updateRequestCount(true));

        return axios.get(Utilities.buildUrl("/Catalog/CategoryProducts"), {
            params: { categoryId, includeSpecs, includeAttributes, includeSubProducts, pageNumber }
        })
            .then(res => {
                dispatch(receivedServerError(false));
                dispatch(receivedZebraTC58Accessories(res.data.products));
                dispatch(updateRequestCount(false));

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }
            })
            .catch(error => {
                dispatch(updateRequestCount(false));

                if (error.response.status === 401 || error.response.status === 403) {
                    redirectToLoginPage();
                } else {
                    dispatch(receivedServerError(true, error.response.data));
                    dispatch(receivedServerError(false));
                }

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }
            });
    };
}

function receivedZebraTC58Accessories(data) {
    return {
        type: ZEBRA_TC58_ACCESSORIES_RECEIVED,
        payload: data
    };
}

export function getZebraTC78Accessories(categoryId, includeSpecs = false, includeAttributes = false, includeSubProducts = false, pageNumber = 1) {
    return function (dispatch, getState) {
        dispatch(toggleBlockingStatus(true));
        dispatch(updateRequestCount(true));

        return axios.get(Utilities.buildUrl("/Catalog/CategoryProducts"), {
            params: { categoryId, includeSpecs, includeAttributes, includeSubProducts, pageNumber }
        })
            .then(res => {
                dispatch(receivedServerError(false));
                dispatch(receivedZebraTC78Accessories(res.data.products));
                dispatch(updateRequestCount(false));

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }
            })
            .catch(error => {
                dispatch(updateRequestCount(false));

                if (error.response.status === 401 || error.response.status === 403) {
                    redirectToLoginPage();
                } else {
                    dispatch(receivedServerError(true, error.response.data));
                    dispatch(receivedServerError(false));
                }

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }
            });
    };
}

function receivedZebraTC78Accessories(data) {
    return {
        type: ZEBRA_TC78_ACCESSORIES_RECEIVED,
        payload: data
    };
}

export function getPanasonicAccessories(categoryId, includeSpecs = false, includeAttributes = false, includeSubProducts = false, pageNumber = 1) {
    return function(dispatch, getState) {
        dispatch(toggleBlockingStatus(true));
        dispatch(updateRequestCount(true));

        return axios.get(Utilities.buildUrl("/Catalog/CategoryProducts"), {
            params: { categoryId, includeSpecs, includeAttributes, includeSubProducts, pageNumber }
        })
            .then(res => {
                dispatch(receivedServerError(false));
                dispatch(receivedPanasonicAccessories(res.data.products));
                dispatch(updateRequestCount(false));

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }
            })
            .catch(error => {
                dispatch(updateRequestCount(false));

                if (error.response.status === 401 || error.response.status === 403) {
                    redirectToLoginPage();
                } else {
                    dispatch(receivedServerError(true, error.response.data));
                    dispatch(receivedServerError(false));
                }

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }
            });
    };
}

function receivedPanasonicAccessories(data) {
    return {
        type: PANASONIC_ACCESSORIES_RECEIVED,
        payload: data
    };
}

export function getPanasonicT1Accessories(categoryId, includeSpecs = false, includeAttributes = false, includeSubProducts = false, pageNumber = 1) {
    return function(dispatch, getState) {
        dispatch(toggleBlockingStatus(true));
        dispatch(updateRequestCount(true));

        return axios.get(Utilities.buildUrl("/Catalog/CategoryProducts"), {
            params: { categoryId, includeSpecs, includeAttributes, includeSubProducts, pageNumber }
        })
            .then(res => {
                dispatch(receivedServerError(false));
                dispatch(receivedPanasonicT1Accessories(res.data.products));
                dispatch(updateRequestCount(false));

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }
            })
            .catch(error => {
                dispatch(updateRequestCount(false));

                if (error.response.status === 401 || error.response.status === 403) {
                    redirectToLoginPage();
                } else {
                    dispatch(receivedServerError(true, error.response.data));
                    dispatch(receivedServerError(false));
                }

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }
            });
    };
}

function receivedPanasonicT1Accessories(data) {
    return {
        type: PANASONIC_T1_ACCESSORIES_RECEIVED,
        payload: data
    };
}

export function getSamsungAccessories(categoryId, includeSpecs = false, includeAttributes = false, includeSubProducts = false, pageNumber = 1) {
    return function(dispatch, getState) {
        dispatch(toggleBlockingStatus(true));
        dispatch(updateRequestCount(true));

        return axios.get(Utilities.buildUrl("/Catalog/CategoryProducts"), {
            params: { categoryId, includeSpecs, includeAttributes, includeSubProducts, pageNumber }
        })
            .then(res => {
                dispatch(receivedServerError(false));
                dispatch(receivedSamsungAccessories(res.data.products));
                dispatch(updateRequestCount(false));

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }
            })
            .catch(error => {
                dispatch(updateRequestCount(false));

                if (error.response.status === 401 || error.response.status === 403) {
                    redirectToLoginPage();
                } else {
                    dispatch(receivedServerError(true, error.response.data));
                    dispatch(receivedServerError(false));
                }

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }
            });
    };
}

function receivedSamsungAccessories(data) {
    return {
        type: SAMSUNG_ACCESSORIES_RECEIVED,
        payload: data
    };
}

export function getUniversalAccessories(categoryId, includeSpecs = false, includeAttributes = false, includeSubProducts = false, pageNumber = 1) {
    return function(dispatch, getState) {
        dispatch(toggleBlockingStatus(true));
        dispatch(updateRequestCount(true));

        return axios.get(Utilities.buildUrl("/Catalog/CategoryProducts"), {
            params: { categoryId, includeSpecs, includeAttributes, includeSubProducts, pageNumber }
        })
            .then(res => {
                dispatch(receivedServerError(false));
                dispatch(receivedUniversalAccessories(res.data.products));
                dispatch(updateRequestCount(false));

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }
            })
            .catch(error => {
                dispatch(updateRequestCount(false));

                if (error.response.status === 401 || error.response.status === 403) {
                    redirectToLoginPage();
                } else {
                    dispatch(receivedServerError(true, error.response.data));
                    dispatch(receivedServerError(false));
                }

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }
            });
    };
}

function receivedUniversalAccessories(data) {
    return {
        type: UNIVERSAL_ACCESSORIES_RECEIVED,
        payload: data
    };
}

export function getPlans(categoryId, includeSpecs = false, includeAttributes = false, includeSubProducts = false, pageNumber = 1) {
    return function(dispatch, getState) {
        dispatch(toggleBlockingStatus(true));
        dispatch(updateRequestCount(true));

        return axios.get(Utilities.buildUrl("/Catalog/CategoryProducts"), {
            params: { categoryId, includeSpecs, includeAttributes, includeSubProducts, pageNumber }
        })
            .then(res => {
                dispatch(receivedServerError(false));
                dispatch(receivedPlans(res.data.products));
                dispatch(updateRequestCount(false));

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }
            })
            .catch(error => {
                dispatch(updateRequestCount(false));

                if (error.response.status === 401 || error.response.status === 403) {
                    redirectToLoginPage();
                } else {
                    dispatch(receivedServerError(true, error.response.data));
                    dispatch(receivedServerError(false));
                }

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }
            });
    };
}

function receivedPlans(data) {
    return {
        type: PLANS_RECEIVED,
        payload: data
    };
}

export function getServices(categoryId, includeSpecs = false, includeAttributes = false, includeSubProducts = false, pageNumber = 1) {

    return function(dispatch, getState) {
        // dispatch(toggleBlockingStatus(true));
        dispatch(updateRequestCount(true));

        return axios.get(Utilities.buildUrl("/Catalog/CategoryProducts"), {
            params: { categoryId, includeSpecs, includeAttributes, includeSubProducts, pageNumber }
        })
            .then(res => {
                dispatch(receivedServerError(false));
                dispatch(receivedServices(res.data.products));
                dispatch(updateRequestCount(false));

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }
            })
            .catch(error => {
                dispatch(updateRequestCount(false));

                if (error.response.status === 401 || error.response.status === 403) {
                    redirectToLoginPage();
                } else {
                    dispatch(receivedServerError(true, error.response.data));
                    dispatch(receivedServerError(false));
                }

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }
            });
    };
}

function receivedServices(data) {
    return {
        type: SERVICES_RECEIVED,
        payload: data
    };
}

export function updateKitQuantity(quantity) {
    return {
        type: KIT_QUANTIY_UPDATED,
        payload: quantity
    };
}

export function updateDeviceQuantity(quantity) {
    return {
        type: DEVICE_QUANTIY_UPDATED,
        payload: quantity
    };
}

export function selectProduct(product) {
    return {
        type: PRODUCT_SELECTED,
        payload: product
    };
}

